import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import {
  editCustomPlan,
  getCustomPlan,
} from "store/actions";
import Loader from "components/shared/loader";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import SaveChangesButton from "components/Form/SaveChangesButton";
import FormWrapper from "components/Form/FormWrapper";
import Input from "components/Form/Input";
import ReactSelect from "components/Form/ReactSelect";
import { handleErrMsg } from "helpers/functions";
import { Col, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import InputsGroup from "components/Form/InputsGroup";
import Form from "components/Form";

const EditCustomPlan = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id, applicationId } = useParams();
  const { loading, error, singleCustomPlan } = useSelector(
    (state) => state.customPlans
  );

  const {
    setValue,
    register,
    control,
    watch,
    reset,
    formState: { errors },
  } = useForm();
  useEffect(() => {
    reset({
      ...singleCustomPlan,
      expiryDate: singleCustomPlan?.expiryDate?.split("T")?.[0],
    });
  }, [reset, singleCustomPlan]);

  // effects
  useEffect(() => {
    dispatch(getCustomPlan({ id, applicationId }));
  }, [dispatch, id, applicationId]);

  // error
  useEffect(() => {
    if (Object.keys(error)?.length > 0) {
      toastErrorMessage(formatMessage({ id: handleErrMsg(error) }), locale);
    }
  }, [error, formatMessage, locale, navigate]);

  const includedApps = watch("includedApps");
  useEffect(() => {
    if (includedApps?.length === 0)
      return setValue("includedApps", ["allApps"]);
    if (includedApps?.includes("allApps") && includedApps?.length !== 1)
      setValue("includedApps", ["allApps"]);
  }, [includedApps, setValue]);

  const onSubmit = (data) => {
    dispatch(editCustomPlan({ applicationId, id, data, navigate }));
  };

  if (loading) return <Loader />;

  return (
    <div className="applications customPlans">
      <FormWrapper title={"addCustomPlan"} lg={12}>
        <Col lg={12}>
          <Form onSubmit={onSubmit} defaultValues={singleCustomPlan}>
            <div className="form-group branches features">
              <Row>
                <ReactSelect
                  name="planType"
                  options={["oneTime", "monthly", "yearly"]}
                  lg="6"
                  control={control}
                  errors={errors}
                />

                <Input
                  type="number"
                  name="price"
                  xs="11"
                  register={register}
                  errors={errors}
                />
                <Input
                  name="storeName"
                  xs="11"
                  register={register}
                  errors={errors}
                />
                <Input
                  type="url"
                  name="storeUrl"
                  xs="11"
                  register={register}
                  errors={errors}
                />

                <InputsGroup
                  name="features"
                  inputs={[
                    {
                      name: "",
                      type: "text",
                      locales: ["ar", "en"],
                      langId: "feature",
                    },
                  ]}
                />

                <SaveChangesButton className="mt-2 justify-content-end" />
              </Row>
            </div>
          </Form>
        </Col>
      </FormWrapper>
    </div>
  );
};

export default EditCustomPlan;
